import { graphql, useStaticQuery } from 'gatsby';

import { QueryFragments } from './queryFragments'; // eslint-disable-line

export const useSiteConfig = () => {
  const { sanitySiteConfig } = useStaticQuery(graphql`
    query {
      sanitySiteConfig {
        mainNav {
          topLink
          subLinks {
            ... on SanityPathLink {
              _type
              ...PathLinkFields
            }
            ... on SanityPageLink {
              _type
              ...PageLinkFields
            }
          }
        }
        address1
        address2
        donations: _rawDonationsModal(resolveReferences: { maxDepth: 100 })
        email
        phone
        eventBannerText: _rawEventBannerText(
          resolveReferences: { maxDepth: 100 }
        )
        faq: _rawFaq(resolveReferences: { maxDepth: 100 })
        footerBannerText {
          heading
          text
        }
        footerCopy
        socials {
          icon {
            ...ImageWithPreview
          }
          url
        }
        footerImages {
          icon {
            ...ImageWithPreview
          }
          url
        }
        klaviyoListId
      }
    }
  `);
  return sanitySiteConfig || {};
};
